/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { getRouterInfo } from '@ideapa/app-routing-utils';
import { Ente } from '@ideapa/app-shared-ente';
import { Modulo } from '@ideapa/app-shared-modulo';
import { Partecipata } from '@ideapa/app-shared-partecipata';
// import { UserWithEntiDto } from '@ideapa/common-dto';
// import { DeepPartial, RoleCode } from '@ideapa/common-utils';
import { RoleCode } from '@ideapa/common-utils';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AUTH_FEATURE_KEY, AuthState } from './auth.reducer';

// Lookup the 'Auth' feature state managed by NgRx
export const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const selectLoginForm = createSelector(getAuthState, (s) => s.loginForm);
export const selectLoggedUser = createSelector(
  getAuthState,
  (s) => s.loggedUser
);

export const selectUserMustResetPassword = createSelector(
  getAuthState,
  (s) => s.userMustResetPassword
);

export const selectAuthError = createSelector(getAuthState, (s) => s.authError);

export const resetPasswordEmailSent = createSelector(
  getAuthState,
  (s) => s.resetPasswordEmailSent
);

// export const selectQueryDomain = createSelector(
//   getRouterInfo,
//   (r) => r.queryParams.domainId
// );

export const selectForgotPasswordForm = createSelector(
  getAuthState,
  (s) => s.forgotPasswordForm
);
export const selectResetPasswordForm = createSelector(
  getAuthState,
  (s) => s.resetPasswordForm
);

export const selectQueryParams = createSelector(
  getRouterInfo,
  (r) => r.queryParams
);

export const modulo = createSelector(getAuthState, (s) => s.modulo);
export const ente = createSelector(getAuthState, (s) => s.ente);
export const anno = createSelector(getAuthState, (s) =>
  s.anno ? Number(s.anno) : null
);
export const isAdmin = createSelector(
  getAuthState,
  (s) =>
    s.loggedUser?.role?.code == RoleCode.Admin ||
    s.loggedUser?.role?.code == RoleCode.SuperAdmin
);

// export const availableModules = createSelector<
//   any,
//   UserWithEntiDto | undefined,
//   Modulo[],
//   DeepPartial<Modulo>[]
// >(selectLoggedUser, sharedModuloSelectors.getAll, (user, allModuli) => {
export const availableModules = createSelector(selectLoggedUser, (user) => {
  const moduliToReturn: Modulo[] = [];
  if (user && user.entiAssociati.length > 0) {
    const enti = user.entiAssociati;
    enti.forEach((e) => {
      if (e.moduli) {
        const moduli = e.moduli;
        moduli.forEach((nuovoModulo) => {
          if (
            nuovoModulo.modulo &&
            moduliToReturn.findIndex((m) => m.id === nuovoModulo.idModulo) ===
              -1
          ) {
            const entiPerModulo: Ente[] = [];
            enti.forEach((ente) => {
              if (ente.moduli) {
                const idModuliPerEnte = ente.moduli.map(
                  (moduloEnte) => moduloEnte.idModulo
                );
                const idModulo = nuovoModulo.idModulo;

                if (idModuliPerEnte.indexOf(idModulo) >= 0) {
                  entiPerModulo.push(ente);
                }
              }
            });

            const modulo: Modulo = {
              ...nuovoModulo.modulo,
              entiAssociati: entiPerModulo,
            };

            moduliToReturn.push(modulo);
          }
        });
      }
    });
  } else if (
    user?.role?.code == RoleCode.CompanyUser &&
    user.partecipateAssociate.length > 0
  ) {
    // verifica se  && user.partecipate
    const partecipate: Partial<Partecipata>[] =
      user.partecipate?.map((m) => {
        return {
          id: m.idPartecipata,
          codice: m.partecipata?.codice,
          ragioneSociale: m.partecipata?.ragioneSociale,
        };
      }) || [];
    // const moduloPartecipo = allModuli.find((m) => m.codice == 'partecipo');
    // mockato perché non posso includere lo shared state dei moduli
    const moduloPartecipo: Modulo = {
      id: 2,
      nome: 'Consolid@to',
      codice: 'partecipo',
      colore: '#1D70FF',
      titolo: 'Gestione Partecipate e Bilancio Consolidato',
    };
    if (moduloPartecipo) {
      const modulo: Modulo = {
        ...moduloPartecipo,
        partecipateAssociate: partecipate,
      };
      moduliToReturn.push(modulo);
    }
  }
  return moduliToReturn;
});

export const getSelectModuloForm = createSelector(
  getAuthState,
  (s) => s.selectModuloForm
);

export const getSelectModuloPartecipataForm = createSelector(
  getAuthState,
  (s) => s.selectModuloPartecipataForm
);

export const getChangePasswordForm = createSelector(
  getAuthState,
  (s) => s.changePasswordForm
);

// MFA
export const getVerifyMAForm = createSelector(
  getAuthState,
  (s) => s.MAVerifyCodeForm
);
export const getVerifyEmailOtpForm = createSelector(
  getAuthState,
  (s) => s.EmailOtpVerifyCodeForm
);
